'use client';

import { useCallback } from 'react';
import { useTransactionContext } from '../contexts/transactions-context';
import { useAccount } from 'wagmi';

export default function useTransactionAdder() {
    const { dispatch } = useTransactionContext();
    const { address: account } = useAccount();
    const { chain } = useAccount();

    return useCallback(
        (response: any, { summary, approval, claim }: any = {}) => {
            if (!account || !chain) return;

            const { hash } = response;
            if (!hash) {
                throw Error('No transaction hash found.');
            }

            dispatch({
                type: 'ADD_TRANSACTION',
                payload: { hash, from: account, chainId: chain.id, approval, summary, claim },
            });
        },
        [dispatch, account, chain]
    );
}